const set_percent_additional = (item, field) => {
  let result = item[field];
  let percent_field = `${field}_percent`;

  if (item.hasOwnProperty(percent_field)) {
    result = `${result} (${item[percent_field]}%)`;
  }

  return result;
};

export default {
  namespaced: true,
  state     : {
    employee_study_org: {
      content: {
        search    : '',
        pagination: {
          rowsPerPage: 10,
        },
        headers: [
          {text: 'Компания', value: 'name', sort: true},
          {text: 'Страна', value: 'country_name', sort: true},
          {text: 'Кол-во курсов', value: 'all_course_count', sort: true},
          {text: 'Статус "Новый"', value: 'new_course_count', sort: true},
          {
            text       : 'Статус "Идет обучение"',
            value      : 'status',
            inner_items: [
              {
                text : 'Не просрочен',
                value: 'not_expired_course_history_count',
                sort : true,
              },
              {
                text : 'Просрочен',
                value: 'expired_course_history_count',
                sort : true,
              },
            ],
          },
          {text: 'Статус "Завершен"', value: 'completed_course_count', sort: true},
          {text: 'Рейтинг', value: 'company_rating', sort: true},
          {text: 'Ср. балл', value: 'average_users_points', sort: true},
        ],
        body: [],
      },
    },
    showed_org_filter   : false,
    example_organization: {
      id           : 22,
      name         : 'Организация пример',
      directorate  : 50,
      courses_stats: {
        total      : 500,
        new        : 20,
        finished   : 100,
        in_progress: 380,
        not_overdue: 300,
        overdue    : 80,
      },
    },
  },
  getters: {
    example_organization       : ({example_organization}) => example_organization,
    showed_org_filter          : ({showed_org_filter}) => showed_org_filter,
    employee_study_org         : ({employee_study_org}) => employee_study_org,
    employee_study_org_filtered: ({employee_study_org}, getters, rootState) => {
      const search = rootState.employee_study.search;
      let answer = employee_study_org;

      answer.content.body = answer.content.body ? answer.content.body.filter((value) => {
        return value.name.toLowerCase().includes(search.toLowerCase());
      }) : [];

      return answer;
    },
    get_organization_by_id: ({employee_study_org}, {}, {route}, rootGetter) => {
      let current_id = route.query.organization;
      return employee_study_org.content.body.find((item)=>item.id === current_id);
    },
  },
  mutations: {
    TOGGLE_ORG_FILTER(state) {
      state.showed_org_filter = !state.showed_org_filter;
    },
    SHOW_ORG_NUMBER(state, selected) {
      const table = state.employee_study_org.content;
      table.pagination.rowsPerPage = selected;
    },
    SET_ORG_PAGINATION(state, value) {
      let table = state.employee_study_org.content;
      table.pagination = value;
    },
    SET_ORG_PAGE(state, value) {
      let table = state.employee_study_org.content;
      table.pagination.page = value;
    },
    CHANGE_ORG_SORT(state, column) {
      let table = state.employee_study_org.content;
      if (table.pagination.sortBy === column) {
        table.pagination.descending = !table.pagination.descending;
      } else {
        table.pagination.sortBy = column;
        table.pagination.descending = false;
      }
    },
    SEARCH_ORG(state, value) {
      state.employee_study_org.content.search = value;
    },

    SET_ORG(state, value) {
      state.employee_study_org.content.body = value.map((org) => ({
        ...org,
        new_course_count      : set_percent_additional(org, 'new_course_count'),
        completed_course_count: set_percent_additional(org, 'completed_course_count'),
        status                : {
          not_expired_course_history_count: set_percent_additional(org, 'not_expired_course_history_count'),
          expired_course_history_count    : set_percent_additional(org, 'expired_course_history_count'),
        },
      }));
    },
    SET_PAGINATION(state, value) {
      state.employee_study_org.content.pagination = {...state.employee_study_org.content.pagination, ...value};
    },
  },
  actions: {
    async change_organization_per_page({commit}, event) {
      commit('SHOW_ORG_NUMBER', event);
      commit('SET_ORG_PAGE', 1);
    },
  },
};
